import React from 'react';
import PropTypes from 'prop-types';
import { connectToStores } from 'fluxible-addons-react';
import OnlineStatusStore from 'stores/OnlineStatusStore';
import OnlineStatusActionCreators from 'actions/OnlineStatusActionCreators';

export default function connectToOnlineStatus(Component) {
    class OnlineStatus extends React.Component {
        componentDidMount() {
            this.updateOnlineStatus(this.props.lastSeenTimesUrl);
            this.createUpdateTimer(this.props.lastSeenTimesUrl);
        }

        UNSAFE_componentWillReceiveProps(nextProps) {
            if (nextProps.lastSeenTimesUrl !== this.props.lastSeenTimesUrl) {
                this.destroyTimer();
                this.updateOnlineStatus(nextProps.lastSeenTimesUrl);
                this.createUpdateTimer(nextProps.lastSeenTimesUrl);
            }
        }

        componentWillUnmount() {
            this.destroyTimer();
        }

        destroyTimer() {
            clearInterval(this.updateTimer);
        }

        createUpdateTimer(lastSeenTimesUrl) {
            this.updateTimer = setInterval(() => {
                this.updateOnlineStatus(lastSeenTimesUrl);
            }, 60000);
        }

        updateOnlineStatus(lastSeenTimesUrl) {
            this.context.executeAction(OnlineStatusActionCreators.getOnlineStatus, {
                lastSeenTimesUrl,
            });
        }

        render() {
            return <Component {...this.props} />;
        }
    }

    OnlineStatus.defaultProps = {
        isOnline: false,
    };

    OnlineStatus.propTypes = {
        lastSeenTimesUrl: PropTypes.string.isRequired,
        isOnline: PropTypes.bool,
    };

    OnlineStatus.contextTypes = {
        executeAction: PropTypes.func.isRequired,
    };

    // Connect to the store that provides the data
    return connectToStores(OnlineStatus, [OnlineStatusStore], (context, props) => ({
        isOnline: context.getStore(OnlineStatusStore).getOnlineStatus(props.user.id),
    }));
}



// WEBPACK FOOTER //
// ./src/js/components/connectToOnlineStatus.jsx